import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { __RouterContext, RouteComponentProps } from 'react-router';

export function useRouter(): RouteComponentProps {
  return useContext(__RouterContext);
}

export function useTransRedirect(): (path: string, state?: any) => void {
  const [url] = useTranslation('url');
  const { history } = useRouter();
  return (path: string, state?: any) => {
    let to = path.split('/').reduce((result, c) => `${result}${url(c)}/`, '');
    to = to.substring(0, to.length - 1);
    history.push(to, state);
  }
}
